import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { OrganizationScreen } from 'screens/organization';

export default withPermissions(OrganizationScreen, [
  GroupSecurity.OrganizationRead,
]);
